import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
// import { useGetCourQuery } from "../../app/services/courApi";
import Loader from "../loader/Loader";

function HistoriqueTable(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  // const { data: devises, isLoading, isError } = useGetCourQuery(props.bureauId);
  const [editableDevises, setEditableDevises] = useState([]);

  return (
    <Box sx={{ backgroundColor: "white" }}>
      <TableContainer sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Nom</TableCell>
              <TableCell>Pays</TableCell>
              <TableCell>Prix d'achat (MAD)</TableCell>
              <TableCell>Prix de vente (MAD)</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.cours.map((cour) => (
              <TableRow key={cour.id}>
                <TableCell>
                  <img
                    src={`${process.env.REACT_APP_BASE_FILE_URL}/Devise/image/${cour.devise.image}`}
                    alt={cour.devise.name}
                    style={{
                      width: 40,
                      height: 32,
                      cursor: "pointer",
                      transition: "transform 0.2s ease-in-out", // Animation fluide
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.2)")
                    } // Agrandir au survol
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    } // Revenir à la taille normale
                    onClick={() =>
                      navigate(`/admin/historiquedevise/${cour.id}`)
                    }
                  />
                </TableCell>
                <TableCell>{cour.devise.name}</TableCell>
                <TableCell>{cour.devise.pays}</TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    size="small"
                    value={cour.prixAchat}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    size="small"
                    value={cour.prixVente}
                  />
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      navigate(`/admin/historiquedevise/${cour.id}`)
                    }
                  >
                    Historique
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default HistoriqueTable;
